export const defaultProfile = {
    customerType: null,
};
export const stringifyProfile = (profile) => {
    return JSON.stringify(profile);
};
export const parseProfile = (profile) => {
    try {
        return JSON.parse(profile);
    }
    catch (e) {
        return defaultProfile;
    }
};
//# sourceMappingURL=customerProfile.js.map